const commonStrings = {
  sidebar: {
    logoImageAltText: 'vezeeta logo',
    bulkOrderItemName: 'Bulk Order',
  },

  header: {
    userNameText: 'Hi,',
    logoutText: 'Logout',
  },

  singleFileUploader: {
    attachFiles: 'Attach Files',
  },
};

export default commonStrings;
